module.exports = __webpack_public_path__ + "static/media/seroTitle.e554279d.jpeg";